const t = "styles-module__modal___7GJy2", o = "styles-module__fullscreen___rrgJD", e = "styles-module__closing___g7UCO", _ = "styles-module__modalContent___zwCa0", l = "styles-module__modalSimpleContent___5Ol95", n = "styles-module__authStyle___J-MhA", s = "styles-module__close___-5nmV", c = "styles-module__logo___7MTbQ", d = "styles-module__titleContainer___AN8Qs", i = "styles-module__titleIcon___lVWeZ", u = "styles-module__title___2gMGD", m = "styles-module__content___rc4Wh", r = "styles-module__description___03WjX", a = "styles-module__childrenContainer___Folgd", y = "styles-module__buttonContainer___Y1YTc", C = "styles-module__primaryButton___1A7gb", g = "styles-module__secondaryButton___uEh3I", p = "styles-module__footer___ZHN4i", h = {
  modal: t,
  fullscreen: o,
  closing: e,
  modalContent: _,
  modalSimpleContent: l,
  authStyle: n,
  close: s,
  logo: c,
  titleContainer: d,
  titleIcon: i,
  title: u,
  content: m,
  description: r,
  childrenContainer: a,
  buttonContainer: y,
  primaryButton: C,
  secondaryButton: g,
  footer: p
};
export {
  n as authStyle,
  y as buttonContainer,
  a as childrenContainer,
  s as close,
  e as closing,
  m as content,
  h as default,
  r as description,
  p as footer,
  o as fullscreen,
  c as logo,
  t as modal,
  _ as modalContent,
  l as modalSimpleContent,
  C as primaryButton,
  g as secondaryButton,
  u as title,
  d as titleContainer,
  i as titleIcon
};
